<template>
  <v-snackbar
    v-model="active"
    :color="snackbarColor"
    timeout="-1"
    right
    bottom
    class="ml-4 legacy-web-popup"
    elevation="24"
    transition="fade-transition"
  >
    <div v-for="message in messages" :key="message">
      <span class="font-weight-bold" style="font-size: 16px">{{ message }}</span>
    </div>
    <div v-if="text_link && link" class="mt-3">
      <v-btn
        outlined
        dark
        :loading="actionLoading"
        :disabled="actionLoading"
        @click.stop.prevent="openRequestOrTicket"
      >
        {{ text_link }}
      </v-btn>
    </div>
    <template v-slot:action>
      <v-btn icon small dark @click="active = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import {
  LEGACY_WEB_SSO_ACTION,
  openLegacyWebDashboard,
} from "@/helper/legacyWebAuth";

export default {
  name: "PopupErrorBtnComponent",
  data() {
    return {
      active: false,
      text: "",
      messages: [],
      message: "",
      status: "success",
      link: null,
      copy: null,
      text_link: null,
      CurrentRole: 0,
      actionLoading: false,
    };
  },
  computed: {
    isLegacyWebAction() {
      return (
        this.link &&
        typeof this.link === "object" &&
        this.link.action === LEGACY_WEB_SSO_ACTION
      );
    },
    legacyWebUserId() {
      if (!this.isLegacyWebAction) {
        return null;
      }
      const id = this.link.userId;
      return id != null && id !== "" ? id : null;
    },
    snackbarColor() {
      if (this.status === "orange") {
        return "#FB8C00";
      }
      return this.status;
    },
    copyText() {
      if (typeof this.copy != "object") {
        return this.copy;
      }
      return this.copy.content;
    },
    hrefTarget() {
      return this.link && this.link.newTap ? "_blank" : "_self";
    },
  },
  mounted() {
    this.CurrentRole = window.localStorage.getItem("role");
    this.$root.$on("popup-btn", (status, text, text_link = null, link = null) => {
      this.active = true;
      this.text = text;
      this.status = status;
      this.messages = this.text.split("\n");
      this.link = link;
      this.text_link = text_link;
      this.actionLoading = false;
    });
  },
  methods: {
    async handleLegacyWebSso() {
      const userId = this.legacyWebUserId;
      if (!userId) {
        this.$root.$emit("popup", "error", "تعذر تحديد المستخدم");
        return;
      }

      this.actionLoading = true;
      try {
        await openLegacyWebDashboard(userId);
        this.active = false;
      } catch (err) {
        const msg =
          err?.response?.data?.message ||
          err?.message ||
          "تعذر فتح لوحة الويب";
        this.$root.$emit("popup", "error", msg);
      } finally {
        this.actionLoading = false;
      }
    },

    async openRequestOrTicket() {
      if (this.isLegacyWebAction) {
        await this.handleLegacyWebSso();
        return;
      }

      this.active = false;
      if (this.text_link == "فتح التذكرة") {
        this.$router.push({
          name: this.ticketDetailsRouteName(),
          params: { ticket: this.link },
        });
      } else if (this.text_link == "فتح الطلب") {
        this.$router.push({
          name: this.requestDetailsRouteName(),
          params: { id: this.link },
        });
      } else if (this.text_link == "فتح الاستبيان") {
        if (this.CurrentRole == "2") {
          this.$router.push({
            name: "FundingQuestionAndAnswer",
            query: { required: "1" },
          });
        } else {
          this.$router.push({
            name: "questionnaire_details",
            params: { id: this.link },
          });
        }
      } else if (this.link && this.link.url) {
        window.open(this.link.url, this.hrefTarget, "noopener,noreferrer");
      }
    },

    ticketDetailsRouteName() {
      const routes = {
        1: "salesManager_ticket_details",
        5: "quality_tickets_details",
        7: "admin_tickets_details",
      };

      return routes[this.CurrentRole] || "ticket_details";
    },

    requestDetailsRouteName() {
      const routes = {
        1: "salesManager_request_details",
        5: "quality_request_details",
      };

      return routes[this.CurrentRole] || "request_details";
    },
  },
};
</script>

<style scoped>
.legacy-web-popup >>> .v-btn--outlined {
  border-color: rgba(255, 255, 255, 0.85);
}
</style>
